var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95424 31.0457 -6.10352e-05 20 -6.10352e-05C8.95431 -6.10352e-05 0 8.95424 0 19.9999C0 31.0456 8.95431 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.688965 25.2173C1.84615 29.511 4.39654 33.2324 7.82607 35.8674V25.2173H0.688965Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2609 39.9238C18.8341 39.9731 19.4139 39.9999 20 39.9999C29.2406 39.9999 37.016 33.7326 39.311 25.2173H18.2609V39.9238Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.311 14.7824C37.016 6.26708 29.2406 -0.000183105 20 -0.000183105C19.4139 -0.000183105 18.8341 0.0265356 18.2609 0.0759106V14.7824H39.311Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82607 4.13226C4.39654 6.76742 1.84615 10.4887 0.688965 14.7824H7.82607V4.13226Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3912H15.6523H15.6522V0.475281C13.8039 0.885124 12.0516 1.54942 10.4348 2.43169V17.3911H0.169297C0.0579688 18.2451 0 19.1157 0 19.9999C0 20.884 0.0579688 21.7547 0.169297 22.6086H10.4347H10.4348V37.568C12.0516 38.4502 13.8039 39.1147 15.6522 39.5244V22.6088V22.6086H39.8307C39.9419 21.7547 40 20.884 40 19.9999C40 19.1157 39.9419 18.2451 39.8307 17.3912V17.3912Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceland);
export default __webpack_public_path__ + "static/media/iceland.73eed49e0f32ce8e0735392c2e9dc243.svg";
export { ForwardRef as ReactComponent };